// extracted by mini-css-extract-plugin
export default {"lost-password":"LoginForm_lost-password__0NonV"};